export function savePhoneContact(phone: string){

    const vcard = `BEGIN:VCARD\nVERSION:4.0\nTEL;TYPE=work,voice:+${phone}\nEND:VCARD`;

    const blob = new Blob([vcard], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.download = "Novartis Patient Support.vcf";
    link.textContent = "Novartis Patient Support";
    link.href = url;

    link.click();
    link.remove();
};